import {createSlice} from '@reduxjs/toolkit';
import {ChooseSpecialtyModalState} from '../../interfaces/connected-components/chooseSpecialtyModal';

const initialState: ChooseSpecialtyModalState = {
  isVisible: false,
};

export const chooseSpecialtyModalSlice = createSlice({
  name: 'chooseSpecialtyModal',
  initialState,
  reducers: {
    showChooseSpecialtyModal: state => {
      state.isVisible = true;
    },
    hideChooseSpecialtyModal: state => {
      state.isVisible = false;
    },
  },
});

// Action creators are generated for each case reducer function
export const {showChooseSpecialtyModal, hideChooseSpecialtyModal} =
  chooseSpecialtyModalSlice.actions;

export default chooseSpecialtyModalSlice.reducer;
